import { IStakeholders } from "../../interfaces/stakeholders";
import { setSTAKEHOLDERSOBJECT } from "../constants/stakeholders.types";

export const setStakeholdersObject = (stakeholdersObject: IStakeholders) => {
  return {
    type: setSTAKEHOLDERSOBJECT,
    payload: stakeholdersObject,
  };
};
